import { isEmpty } from 'es-toolkit/compat';
import type { ReactElement } from 'react';
import { FormattedMessage, type IntlShape, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { generateDiscountHint } from './DiscountService';
import { getDiscounts } from './redux/discount.redux';
import type { AccountDiscount, DiscountState } from './redux/types';

const displayAccountDiscount = (accountDiscounts: AccountDiscount[], intl: IntlShape): ReactElement | null => {
    if (accountDiscounts.length < 1) {
        return null;
    }

    const accountDiscount = accountDiscounts[0];
    const discountText = generateDiscountHint(accountDiscount, intl);

    return <div className='margin-top-5 text-color-darkest'>{discountText}</div>;
};

const hasNoDiscount = (discounts: DiscountState) =>
    isEmpty(discounts.accountDiscounts) && isEmpty(discounts.productDiscounts) && isEmpty(discounts.assetDiscounts);

export function DiscountInfoPanel() {
    const discounts = useSelector(getDiscounts);
    const intl = useIntl();

    if (hasNoDiscount(discounts)) {
        return null;
    }

    return (
        <div className='alert alert-success margin-bottom-20 padding-10'>
            <div className='display-flex'>
                <span className='display-flex justify-content-center align-items-center margin-right-10 width-50 height-50'>
                    <span className='text-color-success text-size-h1 uikit-icon icon-cost-efficiency' />
                </span>
                <div>
                    <strong className='text-size-16 text-color-darkest'>
                        <FormattedMessage id={'intl-msg:marketplace.discount.infoPanel.title'} />
                    </strong>
                    {displayAccountDiscount(discounts.accountDiscounts, intl)}
                    <div>
                        <FormattedMessage id={'intl-msg:marketplace.discount.infoPanel.checkoutInfo'} />
                    </div>
                </div>
            </div>
        </div>
    );
}
